var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.5 45.8",
    style: {
      enableBackground: "new 0 0 31.5 45.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,23.4c-6-5.1-10.6-8.9-15-12.9c-3.5-3.1-3.6-6.3-0.7-8.9c2.7-2.3,6.3-2.2,9.5,0.7 c6,5.4,11.9,10.9,17.7,16.5c2.9,2.8,3.1,5.6,0.2,8.4c-6,5.8-12.1,11.4-18.3,16.9c-2.6,2.3-6.1,2.2-8.5,0.1C0,42-0.3,38.5,2.4,36.1 C7,32,12,28.1,17.8,23.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.6f6511d5820555f0a433ab2cd9e2d52b.svg";
export { ForwardRef as ReactComponent };